import { z } from "zod";

export const roleSchema = z.enum(["admin", "member"]);
export const memberSchema = z.object({
  userId: z.string(),
  name: z.string(),
  email: z.string(),
  role: roleSchema,
});
export const pendingMemberSchema = z.object({ email: z.string() });

export type Role = z.infer<typeof roleSchema>;
export type Member = z.infer<typeof memberSchema>;
export type PendingMember = z.infer<typeof pendingMemberSchema>;

export const listOrganizationItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  thumbnailUrl: z.string().nullable(),
  role: roleSchema,
});
export type ListOrganizationItem = z.infer<typeof listOrganizationItemSchema>;

export const listUserOrganizationsResponseSchema = z.object({
  organizations: z.array(listOrganizationItemSchema),
});
